module.exports = __webpack_public_path__ + "img/taken.2c52d5ab.svg";